export const invertedMessages = {
  'Action will not be applied for access items that belong to the certifier.':
    'ShowSelfCertificationNote.Default.Label',
  Success: 'CERTS_SUCCESS',
  'The operation is taking longer than usual. Processing your request in the background.':
    'Certs.bulkAction.info',
  'Resync is in progress. Please retry after some time.': 'Certs.Resync.Info',
};
